'use client';
import { Col, Row, Flex } from 'antd';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import CustButton, { GeneralButtonType } from '../Button';
import { PageRowFragment } from '@/@types/generated/sitecore';
import WaveRightIcon from '../SVG/WaveRightIcon';
import WaveLeftIcon from '../SVG/WaveLeftIcon';
import { WATrackerClickEvn, getButtonLinkWithCID } from '@/utils/wa';
import RichText from '../RichText';
import useALTracker, { EventClickType } from '@/utils/useALTracker';

interface Props {
    content: PageRowFragment & { rowClickEventID?: string; rowPageEventID?: string; rowSecondPageEventID: string };
    data?: any;
}

/** 适用于 pageDetail-Row components */
const PageRow = (props: Props) => {
    // console.log('pageRow------', props);
    const globalStore = useGlobalStore();
    const { ALTrackClickEvent } = useALTracker();
    const {
        rowHeader,
        rowContent,
        buttonAEnable,
        buttonAText,
        buttonALink,
        buttonBEnable,
        buttonBText,
        buttonBLink,
        rowPageEventID,
        rowSecondPageEventID,
        rowClickEventID,
        rowLayout,
    } = props.content;

    const themeColorCode = globalStore.currentTheme?.themeColor;
    const musicWaveColor = globalStore.currentTheme?.musicWaveColor;

    const partyThemeColor =
        props.data?.partyInformation?.partyColorCode?.targetItem?.themeColorCode?.value;

    const currentThemeColor = partyThemeColor ? partyThemeColor : themeColorCode;

    const TITLE_ICON = {
        titleIconRight: () => <WaveRightIcon iconColor={musicWaveColor}></WaveRightIcon>,
        titleIconLeft: () => <WaveLeftIcon iconColor={musicWaveColor}></WaveLeftIcon>,
    };

    const TitleIcon = props.content?.titleIconOptions?.value
        ? TITLE_ICON[props.content?.titleIconOptions?.value as keyof typeof TITLE_ICON]
        : () => null;

    return (
        <Row gutter={[0, 24]} className='max-xmd:px-[20px] pb-5'>
            <Col span={24} className='mt-6'>
                <Flex
                    vertical
                    gap={8}
                    justify={rowLayout?.value === 'Center' ? 'center' : undefined}
                    align={rowLayout?.value === 'Center' ? 'center' : undefined}
                >
                    <RichText html={rowHeader?.rendered || ''} />
                    <TitleIcon />
                </Flex>
                <RichText html={rowContent?.rendered || ''} />
            </Col>
            {(buttonAEnable?.boolValue || buttonBEnable?.boolValue) && (
                <Flex gap={32} align={'center'}>
                    {buttonAEnable?.boolValue && (
                        <CustButton
                            data={{
                                setting: {
                                    onClick: () => {
                                        ALTrackClickEvent(rowClickEventID || '',{
                                            eventType: EventClickType.clickBanner,
                                            url: getButtonLinkWithCID(
                                                buttonALink?.value || '',
                                                rowPageEventID,
                                            ),
                                        });
                                        // WATrackerClickEvn(rowClickEventID);
                                    },
                                },
                                buttonLink: getButtonLinkWithCID(
                                    buttonALink?.value || '',
                                    rowPageEventID,
                                ),
                                currentThemeColor: { background: currentThemeColor || '' },
                            }}
                        >
                            <GeneralButtonType
                                label={buttonAText?.value || ''}
                                icon={'arrowRightBK'}
                            />
                        </CustButton>
                    )}
                    {buttonBEnable?.boolValue && (
                        <CustButton
                            data={{
                                setting: {
                                    type: 'link',
                                    onClick: () => {
                                        ALTrackClickEvent(rowClickEventID || '', {
                                            url: getButtonLinkWithCID(
                                                buttonBLink?.value || '',
                                                rowSecondPageEventID || rowPageEventID,
                                            ),
                                        });
                                        // WATrackerClickEvn(rowClickEventID);
                                    },
                                },
                                buttonLink: getButtonLinkWithCID(
                                    buttonBLink?.value || '',
                                    rowSecondPageEventID || rowPageEventID,
                                ),
                            }}
                        >
                            <GeneralButtonType
                                label={buttonBText?.value || ''}
                                icon={'arrowRightPrimary'}
                                className='!text-base-font-color'
                            />
                        </CustButton>
                    )}
                </Flex>
            )}
        </Row>
    );
};

export default PageRow;
